import * as React from 'react';
import { useLink, useLocation } from '@grandvisionhq/frk-routing';
import { appendQueryParamToUrl } from '../../utils/get-updated-url-with-query-params.js';

const useRedirectToOrderComplete = ()=>{
    const { href: orderConfirmHref  } = useLink({
        route: 'order.confirm',
        params: {
            orderData: ''
        }
    }) || {};
    const { replace  } = useLocation();
    /**
   * @description  redirect to /order/confirm page with query params
   * @argument param json of query parameter key & value
   */ const redirectToOrderComplete = React.useCallback((param)=>{
        if (orderConfirmHref) {
            replace(appendQueryParamToUrl(orderConfirmHref, param));
        } else {
            throw Error('Failed redirection to /order/confirm. Route not found');
        }
    }, [
        orderConfirmHref,
        replace
    ]);
    return redirectToOrderComplete;
};

export { useRedirectToOrderComplete };
//# sourceMappingURL=use-redirect-to-order-confirm-page.js.map
